import { Page, PageTitle } from '../../../components';
import { SageConnectivityStatusDetails } from './SageConnectivityStatusDetails';

export const SageConnectivityStatusPage = () => {
  return (
    <Page title="Sage Connectivity Status">
      <PageTitle title="Sage Connectivity Status" />
      <SageConnectivityStatusDetails />
    </Page>
  );
};
